<div class="background" (click)="modalService.close()"></div>
  <div class="main">
    <h1 class="text-center">{{title}}</h1>
    <ng-content>

    </ng-content>
  </div>
